import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'
import { store } from '../index'

export function fetchTodos(params) {
  return dispatch => {
    dispatch({type: "FETCH_TODOS", data: []});
    myGet(dispatch, servAddr + 'todo', {params}).then((response) => {
      dispatch({type: "FETCH_TODOS", data:response.data});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function fetchCalendarTodos() {
  return dispatch => {
    myGet(dispatch, servAddr + 'todo', {
      params: {calendar: 1}
    }).then((response) => {
      dispatch({type: "FETCH_CALENDAR_TODOS", payload: response.data});
    }, err => {
      handleGetError(dispatch, err);
    });
  }
}

export function editTodo(todo, cb = () => {}) {
  const state = store.getState();
  const model = state.auth.rights.todo_post === 1 ? 'todo' :
    'todo_assigned';
  return dispatch => {
    myPost(dispatch, servAddr + model, {data: todo}).then((response) => {
      if (todo.todo_id) {
        cb();
        dispatch({type: "EDIT_TODO", payload: response.data.updated});
      }
      else {
        cb();
        dispatch({
          type: "CREATE_TODO",
          payload: {
            ...todo,
            todo_id: response.data.id
          }
        });
      }
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/todoActions.js